import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './ReviewPhotoPanel.scss';
import ReviewModal from '../Modals/ReviewModal';
import { getThingtestingMediaImageUrl } from '../../Helpers/thingtesting_helpers';

const MAX_DISPLAY_COUNT = 6;

export const ReviewPhotoPanel = ({ reviews, totalReviews }) => {
  if (!reviews.length) return null;

  const [selectedReview, setSelectedReview] = useState(null);

  const handleClick = (e, review) => {
    e.preventDefault();
    setSelectedReview(review);
  };

  const toDisplay = reviews.slice(0, MAX_DISPLAY_COUNT);
  const lastToDisplay = reviews[MAX_DISPLAY_COUNT];

  return (
    <div className='review-photo-panel'>
      {toDisplay.map(review => (
        <a
          key={review.id}
          href={`https://thingtesting.com/brands/${review.brand.slug}/reviews/${review.id}?utm_source=shopmy&utm_medium=referral`}
          target='_blank'
          rel='noopener noreferrer'
          className='review-photo-panel-item'
          onClick={e => handleClick(e, review)}
        >
          <img src={getThingtestingMediaImageUrl(review.media[0], 'w-1000,h-1000')} alt={`Review by ${review.author.fullName}`} />
        </a>
      ))}

      {lastToDisplay && (
        <a
          href={getThingtestingMediaImageUrl(lastToDisplay.media[0]) || '#'}
          target='_blank'
          rel='noopener noreferrer'
          className='review-photo-panel-item'
          onClick={e => handleClick(e, lastToDisplay)}
        >
          <span className='review-photo-panel-count'>+{totalReviews - MAX_DISPLAY_COUNT}</span>
          <img src={getThingtestingMediaImageUrl(lastToDisplay.media[0], 'w-1000,h-1000')} alt={`Review by ${lastToDisplay.author.fullName}`} />
        </a>
      )}

      {selectedReview && (
        <ReviewModal
          review={selectedReview}
          otherReviews={reviews}
          visible={true}
          close={() => setSelectedReview(null)}
          onNavigate={review => setSelectedReview(review)}
        />
      )}
    </div>
  );
};

ReviewPhotoPanel.propTypes = {
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      brand: PropTypes.shape({
        slug: PropTypes.string.isRequired
      }).isRequired,
      media: PropTypes.arrayOf(
        PropTypes.shape({
          filePath: PropTypes.string.isRequired
        })
      ).isRequired,
      author: PropTypes.shape({
        fullName: PropTypes.string.isRequired
      }).isRequired
    })
  ).isRequired,
  totalReviews: PropTypes.number.isRequired
};
